import {
    loadObjectFromServer,
    getData,
    putData,
    deleteData,
    postData
  } from "@/utils";


  export async function getEmailProviders(){
    const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
    let response = []
    response = await getData(`${APP_ROUTES.CUSTOMERS}/email-provider/`);
    if(response) {
      if(response.api_key && response.api_key!==''){
        return response = response.isArray? response : [response];
      }
    }
    return []
  }